import {useLayoutEffect, useState} from 'react';

import {getStickyChromeOverlapBottomPx} from '@amblique/king-living/app/utils/sticky-chrome';

const BAND_INSET_PX = 6;

/**
 * True when the in-page primary ATC intersects the viewport below sticky header.
 * Used to hide duplicate floating/sticky CTAs while the in-page button is visible.
 */
export function useInPageCtaVisibility(ctaElement) {
  const [hideFloatingCta, setHideFloatingCta] = useState(false);

  useLayoutEffect(() => {
    if (!ctaElement || typeof window === 'undefined') {
      setHideFloatingCta(false);

      return undefined;
    }

    const update = () => {
      const {top: btnTop, bottom: btnBottom} = ctaElement.getBoundingClientRect();
      const chromeBottom = getStickyChromeOverlapBottomPx();
      const viewBottom = window.visualViewport?.height ?? window.innerHeight;

      const inPageAtcVisibleBelowHeader =
        btnBottom > chromeBottom + BAND_INSET_PX && btnTop < viewBottom - BAND_INSET_PX;

      setHideFloatingCta(inPageAtcVisibleBelowHeader);
    };

    update();

    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);

    const headerEl = document.querySelector('[data-header-wrapper]');
    let headerRo;
    let targetRo;

    if (typeof ResizeObserver !== 'undefined') {
      if (headerEl) {
        headerRo = new ResizeObserver(update);
        headerRo.observe(headerEl);
      }

      targetRo = new ResizeObserver(update);
      targetRo.observe(ctaElement);
    }

    return () => {
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
      headerRo?.disconnect();
      targetRo?.disconnect();
    };
  }, [ctaElement]);

  return hideFloatingCta;
}
